module.exports = __webpack_public_path__ + "static/img/2272_phase_function_Paper_Points.511bcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2272_phase_function_Paper_Points.png
// module id = UDgU
// module chunks = 0